export default "__VITE_ASSET__c7a6b772__"